// extracted by mini-css-extract-plugin
export default {"wrapper":"FormPage_wrapper__BsQPw","content":"FormPage_content__1XqLY","header":"FormPage_header__zdp60","card":"FormPage_card__-TJiv"};